const fetcher = (url) =>
    fetch(url).then(async (r) => {
        if (r.status >= 400) {
            throw await r.json();
        }
        return await r.json();
    });
export default fetcher;
